import React, { useEffect, useRef, useState } from 'react';
import './Home.css';
import videoBg from '../assets/scenario_1.mp4';

export default function Home() {
  const videoRef = useRef(null);
  const [soundEnabled, setSoundEnabled] = useState(false);
  const [showSoundPrompt, setShowSoundPrompt] = useState(false);
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) {
      return undefined;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const startVideo = async () => {
      try {
        if (!prefersReducedMotion) {
          await video.play();
        }
      } catch (error) {
        setShowSoundPrompt(false);
      }
    };

    video.defaultMuted = true;
    video.muted = true;
    video.volume = 0;
    video.playsInline = true;
    video.loop = true;

    const handleCanPlay = () => {
      setVideoReady(true);
      startVideo();
    };

    const handleEnded = () => {
      if (!video.loop) {
        video.currentTime = 0;
        startVideo();
      }
    };

    video.addEventListener('canplay', handleCanPlay);
    video.addEventListener('ended', handleEnded);
    startVideo();

    return () => {
      video.removeEventListener('canplay', handleCanPlay);
      video.removeEventListener('ended', handleEnded);
    };
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) {
      return;
    }

    video.defaultMuted = !soundEnabled;
    video.muted = !soundEnabled;
    video.volume = soundEnabled ? 1 : 0;

    try {
      window.localStorage.setItem('homeSoundEnabled', soundEnabled ? 'true' : 'false');
    } catch (error) {
      // Ignore localStorage failures.
    }
  }, [soundEnabled]);

  const handleSoundToggle = async () => {
    const video = videoRef.current;
    if (!video) {
      return;
    }

    try {
      const nextSoundEnabled = !soundEnabled;
      video.defaultMuted = !nextSoundEnabled;
      video.muted = !nextSoundEnabled;
      video.volume = nextSoundEnabled ? 1 : 0;
      await video.play();
      setSoundEnabled(nextSoundEnabled);
      setShowSoundPrompt(false);
    } catch (error) {
      video.defaultMuted = true;
      video.muted = true;
      video.volume = 0;
      setSoundEnabled(false);
      setShowSoundPrompt(true);
    }
  };

  return (
    <div className="home-page">
      <video
        ref={videoRef}
        className={`home-video ${videoReady ? 'is-ready' : ''}`}
        autoPlay
        muted={!soundEnabled}
        loop
        playsInline
        preload="auto"
      >
        <source src={videoBg} type="video/mp4" />
      </video>

      <div className="home-sound-ui">
        <button
          type="button"
          className="sound-toggle-button"
          onClick={handleSoundToggle}
          aria-pressed={soundEnabled}
        >
          {soundEnabled ? 'Sound Off' : 'Enable Sound'}
        </button>

        {showSoundPrompt && (
          <p className="sound-helper-text">
            Browser autoplay restrictions kept the video muted. Tap again to enable sound.
          </p>
        )}
      </div>
    </div>
  );
}
